import { useMutation } from '@apollo/client/react';

import { submitOrder as submitOrderQuery } from '@hooks/submitOrder/query';

const useSubmitOrder = () => {
  const [submitOrderMutation, { loading }] = useMutation(submitOrderQuery);

  const submitOrder = async (basketId: string) => {
    return submitOrderMutation({
      variables: {
        input: {
          basketId,
        },
      },
    });
  };

  return { submitOrder, loading };
};

export { useSubmitOrder };
